/**
 * Слайс userAvatar теперь хранит только version (cache-bust токен) — отдельных
 * thunk-ов не требуется: смена аватара идёт через UserService.setAvatar/deleteAvatar
 * + dispatch(bumpAvatarVersion()). Объект сохранён, чтобы не менять агрегатор
 * allActionCreators.
 */
export const UserAvatarActionCreators = {};
